// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const getIntercom = () => Intercom;

export default getIntercom;
